import '../../../styles/knowledge-concept/KnowledgeConceptHeader.css';

import { AppBar, Box, Button, Toolbar } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectTest } from '../../../store/testSelectionSlice.js';
import { set } from 'lodash';
import { setMainTab } from '../../../store/mainTabSlice.js';
import { setSelectedSideBarValue } from '../../../store/selectedSideBar.js';
import { setSelectedSubTopicData } from '../../../store/selectedSubTopicSlice.js';
import useIsMobile from '../../../hooks/ismobile.js';
import { useNavigate } from 'react-router-dom';

const KnowledgeConceptHeader = ({
	selectedSubTab,
	setSelectedSubTab,
	subTabs,
	setShowLearningInterface,
	setFlashCardHeaderClick,
	setShowAIPath,
	setShowMyPath,
}) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const selectedMainTab = useSelector((state) => state.mainTab.tab_name);
	//const [selectedSubTab, setSelectedSubTab] = useState("KC");

	const mainTabs = [
		{ key: 'READING_WRITING', label: 'Reading & Writing' },
		{ key: 'MATHS', label: 'Maths' },
	];

	const handleMainTabClick = (tab) => {
		//setSelectedMainTab(tab);
		dispatch(setMainTab(tab));
	};

	//const getSelectedSubTab = () => selectedSubTab;

	const handleSubTabClick = (tab) => {
		if (tab === 'KC') {
			dispatch(setSelectedSubTopicData({ topicId: '', subtopicId: '' }));
			dispatch(setSelectedSideBarValue('Notebook'));
			setShowLearningInterface(false);
			setFlashCardHeaderClick(false);
			dispatch(selectTest(null));
		} else if (tab === 'Flashcards') {
			setShowLearningInterface(false);
			setFlashCardHeaderClick(false);
			dispatch(setSelectedSideBarValue('Topics'));
			//navigate(`/flashcardlist`);
			dispatch(selectTest(null));
		} else if (tab === 'Quiz') {
			dispatch(selectTest('SFT'));
		} else if (tab === 'AI Path') {
			setShowLearningInterface(false);
			setFlashCardHeaderClick(false);
			setShowAIPath(true);
		} else if (tab === 'My Path') {
			setShowLearningInterface(false);
			setFlashCardHeaderClick(false);
			setShowMyPath(true);
		}
		setSelectedSubTab(tab);
	};
	const isMobile = useIsMobile();
	return (
		// <div className='exam-header'>
		// 	{/* Main navigation row */}
		// 	<div className='main-nav-row'>
		// 		{mainTabs?.map((tab, index) => (
		// 			<button key={index} className={`nav-button ${selectedMainTab === tab.key ? "active" : ""}`} onClick={() => handleMainTabClick(tab.key)}>
		// 				{tab.label}
		// 			</button>
		// 		))}
		// 	</div>

		// 	{/* Sub navigation row - always visible */}
		// 	<div className='sub-nav-row'>
		// 		{subTabs?.map((tab, index) => (
		// 			<button key={index} className={`nav-button ${selectedSubTab === tab ? "active" : ""}`} onClick={() => handleSubTabClick(tab)}>
		// 				{tab}
		// 			</button>
		// 		))}
		// 	</div>
		// </div>
		<Box className="exam-header">
			<AppBar position="sticky" className="main-nav-row exam-header" sx={{ zIndex: 999 }}>
				<Toolbar>
					{mainTabs?.map((tab, index) => (
						<Box key={index}>
							<Button
								className={`nav-button ${
									selectedMainTab === tab.key ? 'active' : ''
								}`}
								onClick={() => handleMainTabClick(tab.key)}
							>
								{tab.label}
							</Button>
						</Box>
					))}
				</Toolbar>
			</AppBar>
			<AppBar position="sticky" className="sub-nav-row exam-header" sx={{ zIndex: 999 }}>
				<Toolbar
					sx={{ width: { xs: '100vw', sm: '100%' }, overflowX: 'auto', gap: '1rem' }}
				>
					{subTabs?.map((tab, index) => {
						if (tab === 'Quiz' && isMobile) return null;
						return (
							<Box key={index}>
								<Button
									disabled={tab === 'Notebook'}
									className={`nav-button ${
										selectedSubTab === tab ? 'active' : ''
									}`}
									onClick={() => handleSubTabClick(tab)}
								>
									{tab}
								</Button>
							</Box>
						);
					})}
				</Toolbar>
			</AppBar>
		</Box>
	);
};

export default KnowledgeConceptHeader;
